import { useSelector } from 'react-redux'
import {
  IUserPreferenceGeneralListItemType,
  userGeneralPreferencesList,
} from '@user/store/userPreferences/userPreferencesGeneral'
import { useD2DKnockEnabled } from '@user/store/tenantFeatures/hooks/useD2DKnockEnabled'
import { useSalesPersonFilterEnabled } from '@user/store/tenantFeatures/hooks/useSalesPersonFilterEnabled'
import { useAppSelector } from '@user/store/hooks'
import { selectAllKnockStatuses } from '@user/store/knockStatus/slice'

export function useFilterChipData() {
  const userGeneralPreferences = useSelector(userGeneralPreferencesList)
  const d2dKnockEnabled = useD2DKnockEnabled()
  const salesPersonFilterEnabled = useSalesPersonFilterEnabled()
  const knockStatuses = useAppSelector(selectAllKnockStatuses)

  // Get filter state from preferences
  const mapViewFilteredEntityTypesPreference = userGeneralPreferences?.find(
    (row) =>
      row?.type ===
      IUserPreferenceGeneralListItemType.MapViewFilteredEntityTypes,
  )
  const mapViewFilteredMyRecordsPreference = userGeneralPreferences?.find(
    (row) =>
      row?.type === IUserPreferenceGeneralListItemType.MapViewFilteredMyRecords,
  )
  const showMapViewFilterChipsPreference = userGeneralPreferences?.find(
    (row) =>
      row?.type === IUserPreferenceGeneralListItemType.ShowMapViewFilterChips,
  )
  const mapViewFilteredKnockStatusesPreference = userGeneralPreferences?.find(
    (row) =>
      row?.type ===
      IUserPreferenceGeneralListItemType.MapViewFilteredKnockStatuses,
  )

  const filteredRecordsStringValue =
    mapViewFilteredEntityTypesPreference?.value ?? 'draftlead_lead_opportunity'
  const myRecordsOnlyStringValue =
    mapViewFilteredMyRecordsPreference?.value ?? 'true'
  const showFilterChips =
    (showMapViewFilterChipsPreference?.value ?? 'true') === 'true'
  const filteredKnockStatusesStringValue =
    mapViewFilteredKnockStatusesPreference?.value ?? ''

  const selectedTypes = filteredRecordsStringValue.split('_').filter(Boolean)
  // When the salesperson filter is enabled the fetch ignores the my-records
  // preference (effectiveOwnerId is forced to null in ExploratoryMapNew/useApi),
  // so my-records is not actually applied to the returned pins. Treat it as
  // inactive here — the single source of truth for "is my-records active" — so
  // chips, the filter count, the records-hidden-by-filters banner and the
  // record-routing decision all agree with what the map actually returns.
  const myRecords =
    !salesPersonFilterEnabled && myRecordsOnlyStringValue === 'true'
  const selectedKnockStatusIds =
    filteredKnockStatusesStringValue === 'none'
      ? []
      : filteredKnockStatusesStringValue.split('_').filter(Boolean)

  // Map knock status IDs to their full objects for display
  // Compare as strings since preferences are stored as strings but status.id may be a number
  const selectedKnockStatuses = d2dKnockEnabled
    ? selectedKnockStatusIds
        .map((id) => knockStatuses.find((status) => String(status.id) === id))
        .filter(Boolean)
    : []

  return {
    selectedTypes,
    myRecords,
    showFilterChips,
    selectedKnockStatusIds,
    selectedKnockStatuses,
    d2dKnockEnabled,
    filterChipsCount: showFilterChips
      ? selectedTypes.length +
        (myRecords ? 1 : 0) +
        (d2dKnockEnabled ? selectedKnockStatuses.length : 0)
      : 0,
  }
}
